import React, { useEffect } from "react"
import { compose } from "redux"
import { useTranslation } from "react-i18next"
import { RouteComponentProps, withRouter } from "react-router"
import { Paper, Button } from "@material-ui/core"

//HOCs
import withInProgressRecord, { WithInProgressRecordProps } from "../../hoc/withInProgressRecord"

// Constants
import { AppRoute } from "../../../routing/constants"

// Styles
import useStyles from "./styles"

type Props = WithInProgressRecordProps & RouteComponentProps

const InProgressSection = (props: Props) => {
    const { fetchInProgressRecord, inProgressRecordFetching, inProgressRecord, history } = props
    const styles = useStyles();
    const [t] = useTranslation("common")

    useEffect(() => {
        fetchInProgressRecord()
    }, [fetchInProgressRecord])

    const handleContinue = () => {
        history.push(AppRoute.Record);
    }

    if (inProgressRecordFetching || inProgressRecord === null) {
        return null
    }

    return (
        inProgressRecord.recordType == "ECG" ? (
            <Paper className={styles.container} elevation={3}>
                <span className={styles.label}>
                    {t("stats.in_progress_label")}:
                    <span className={styles.label__bold}>
                        {" " + inProgressRecord.fileName}
                    </span>
                </span>
                <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={handleContinue}
                >
                    {t("stats.continue")}
                </Button>
            </Paper>
        ) : (
            null
        )

    )
}

export default compose(
    withInProgressRecord,
    withRouter,
)(InProgressSection)
